/*eslint-disable*/
import React, { Component } from 'react'
import MatImage from '../../AeroComponents/Image'
import { IMAGES_SRC } from '../../AeroComponents/Image/image.constants'

class NotAvailable extends Component {
	render() {
		return (
			<div style={{ textAlign: 'center' }}>
				<div style={{ fontSize: '33px', fontWeight: '300', color: '#373A3C', marginTop: '50px', marginBottom: '20px' }}>This page is not available rigth now</div>
				<MatImage src={IMAGES_SRC.SERVER_DOWN_ICON} />
				<div style={{ fontSize: '16px', marginTop: '30px' }}>Please retry after sometime</div>
			</div>
		)
	}
}

export default NotAvailable
